import React, { useState, useEffect, useRef } from 'react';
import { NavLink } from 'react-router-dom';
import CryptoJS from 'crypto-js';
import axios from 'axios';

const Footer = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [items, setItems] = useState([]); // Store data from the API
  const [error, setError] = useState(null);
  const footerRef = useRef(null); // Reference to the footer element

  const toggleExpand = async () => {
    setIsExpanded(prevState => !prevState);

    if (!isExpanded) {
      try {
        const response = await axios.get('/c3.json');
        const data = response.data.link;
        if (data) {
          let adsArray = Object.keys(data).map(key => ({ ...data[key], id: key }));
          adsArray.forEach((item) => {
            // 解析密文和 IV
             const cipherText = CryptoJS.enc.Base64.parse(item.title[0]); 
             const iv = CryptoJS.enc.Base64.parse(item.title[1]); 
             // 使用固定密钥进行解密
             const key = CryptoJS.enc.Utf8.parse("aafb2b88c91ac2b0"); // 固定的16字节密钥
             // 解密操作
             const decrypted = CryptoJS.AES.decrypt({ ciphertext: cipherText }, key, { iv: iv });
             let plainText = decrypted.toString(CryptoJS.enc.Utf8);
             plainText = plainText.replace(/[\x00-\x1F\x7F-\x9F\x10]+/g, '').trim();
             item.title = plainText;
         });
          setItems(adsArray);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setError('Failed to load data');
      }
    }
  };

  // Handle clicks outside the footer to close it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (footerRef.current && !footerRef.current.contains(event.target)) {
        setIsExpanded(false);
      }
    };

    if (isExpanded) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isExpanded]);

  return (
    <footer
      ref={footerRef}
      style={{
        height: isExpanded ? '80vh' : '40px',
        transition: 'height 0.3s ease',
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        margin: '0',
      }}
    >
      {/* Top section with red background */}
      <div
        onClick={toggleExpand}
        style={{
          backgroundColor: '#CC0000',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center', // Center the content horizontally
          padding: '0 16px',
        }}
      >
        <button
          style={{
            color: 'white',
            fontWeight: 'bold',
            fontSize: '16px', // Set font size
            cursor: 'pointer',
            border: 'none',
            background: 'transparent',
          }}
        >
          {isExpanded ? '收回' : '点击更多资源'}
        </button>
      </div>

      {/* Expanded content area */}
      {isExpanded && (
        <div
          style={{
            backgroundColor: 'rgb(32 32 32 / var(--tw-bg-opacity))',
            height: 'calc(80vh - 40px)',
            overflowY: 'auto',
            padding: '16px',
          }}
        >
          {error && <p className="text-red-500">{error}</p>}
          <div className="grid grid-cols-4 gap-2">
            {(items.length > 0 ? items : Array.from({ length: 10 }, (_, i) => `Item ${i + 1}`))
              .slice(0, 12)
              .map((item, index) => (
                <NavLink
                  key={index}
                  to={item.link}
                  className="border border-tw text-tw px-2 py-1 text-center text-white"
                >
                  {item.title}
                </NavLink>
              ))}
          </div>
          <div className="text-center mt-6">更多资源敬请期待</div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
